export default __webpack_public_path__ + "static/media/p-sm-4.28b1947b.png";